module.exports = __webpack_public_path__ + "img/vaughn-back-patio.3501ce84.jpg";